// 1) Template (from earlier)
var KEEPSAKE_BUNDLE_MODAL_HTML = `
<div class="kb-overlay" id="keepsake-bundle-modal-overlay" role="dialog" aria-modal="true" aria-label="Bundle offer">
  <div class="kb-modal" tabindex="-1">
    <button class="kb-close" type="button" aria-label="Close" data-kb-close>×</button>
    {{PRIMARY_ITEM_SECTION}}

    <div class="kb-title">{{TITLE}}</div>

    <div class="kb-row kb-mockupsRow">
      <div class="kb-card">
        <div class="kb-imgWrap"><img class="kb-img" src="{{IMG_1}}" alt="{{P1_NAME}}"></div>
        <div class="kb-name">{{P1_NAME}}</div>
        <div class="kb-check">✓</div>
      </div>

      <div class="kb-card">
        <div class="kb-imgWrap"><img class="kb-img" src="{{IMG_2}}" alt="{{P2_NAME}}"></div>
        <div class="kb-name">{{P2_NAME}}</div>
        <div class="kb-check">✓</div>
      </div>

      <div class="kb-card">
        <div class="kb-imgWrap"><img class="kb-img" src="{{IMG_3}}" alt="{{P3_NAME}}"></div>
        <div class="kb-name">{{P3_NAME}}</div>
        <div class="kb-check">✓</div>
      </div>
    </div>

    <div class="kb-bundleLine">{{BUNDLE_NAME}}</div>

    <div class="kb-priceRow">
      <div class="kb-priceNow">{{PRICE_NOW}}</div>
      <div class="kb-priceWas">{{PRICE_WAS}}</div>
    </div>

    <div class="kb-saveLine">{{SAVE_LINE}}</div>
    <div class="kb-free-shipping">+ Free Shipping</div>

    <button class="kb-cta" type="button" data-kb-cta>{{CTA_TEXT}}</button>
    <div class="kb-no-thanks-wrap {{NO_THANKS_WRAP_CLASS}}">
      <button class="kb-no-thanks {{NO_THANKS_CLASS}}" type="button" data-kb-no-thanks>{{NO_THANKS_TEXT}}</button>
    </div>
  </div>
</div>
`;

// 2) Pull the 3 image URLs from the page
function getKeepsakeMockupUrls() {
    var imgs = document.querySelectorAll("img.keepsake-pricing-mockup");
    return [
        (imgs[0] && (imgs[0].currentSrc || imgs[0].src)) || "",
        (imgs[1] && (imgs[1].currentSrc || imgs[1].src)) || "",
        (imgs[2] && (imgs[2].currentSrc || imgs[2].src)) || ""
    ];
}

function escapeKeepsakeHtml(value) {
    return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

// 3) Replace shortcodes + inject HTML + bind events
function renderKeepsakeBundleModal(options) {
    // remove existing
    var existing = document.getElementById("keepsake-bundle-modal-overlay");
    if (existing) existing.remove();

    var urls = getKeepsakeMockupUrls();

    var primaryItem = typeof options.getPrimaryItemDetails === "function" ? options.getPrimaryItemDetails() : options.primaryItem;
    var primaryItemHtml = "";
    if (primaryItem && (primaryItem.imageUrl || primaryItem.title || primaryItem.price)) {
        var imageUrl = escapeKeepsakeHtml(primaryItem.imageUrl || "");
        var titleText = escapeKeepsakeHtml(primaryItem.title || "");
        var priceText = escapeKeepsakeHtml(primaryItem.price || "");
        var priceWasText = escapeKeepsakeHtml(primaryItem.priceWas || "");
        primaryItemHtml =
            '<div class="kb-primary-item">' +
            '<div class="kb-primary-thumb-wrap">' +
            '<img class="kb-primary-thumb" src="' + imageUrl + '" alt="">' +
            '<span class="kb-primary-check" aria-hidden="true">✓</span>' +
            '</div>' +
            '<div class="kb-primary-info">' +
            '<div class="kb-primary-title">' + titleText + '</div>' +
            '<div class="kb-primary-price">' + priceText +
            (priceWasText ? '<span class="kb-primary-price-was">' + priceWasText + '</span>' : '') +
            '</div>' +
            '</div>' +
            '</div>';
    }

    var replacements = {
        "{{PRIMARY_ITEM_SECTION}}": primaryItemHtml,
        "{{TITLE}}": options.title || "Save When You Bundle All 3 Products",
        "{{BUNDLE_NAME}}": options.bundleName || "Download, Wall Canvas & Puzzle Bundle",
        "{{PRICE_NOW}}": options.priceNow || "$65",
        "{{PRICE_WAS}}": options.priceWas || "$137",
        "{{SAVE_LINE}}": options.saveLine || "Save $72 by bundling all 3 products!",
        "{{CTA_TEXT}}": options.ctaText || "ADD BUNDLE TO CART",
        "{{P1_NAME}}": options.p1Name || "Instant Download",
        "{{P2_NAME}}": options.p2Name || "Wall Canvas",
        "{{P3_NAME}}": options.p3Name || "300 Piece Puzzle",
        "{{IMG_1}}": options.img1 || urls[0],
        "{{IMG_2}}": options.img2 || urls[1],
        "{{IMG_3}}": options.img3 || urls[2],
        "{{NO_THANKS_TEXT}}": options.noThanksText || "No Thanks",
        "{{NO_THANKS_CLASS}}": options.noThanksClass || "",
        "{{NO_THANKS_WRAP_CLASS}}": options.noThanksWrapClass || ""
    };

    var html = KEEPSAKE_BUNDLE_MODAL_HTML;

    // simple global replace for each shortcode
    Object.keys(replacements).forEach(function (key) {
        html = html.split(key).join(replacements[key]);
    });

    // inject
    var modalHost = document.querySelector(".preview-section") || document.querySelector("main") || document.body;
    modalHost.insertAdjacentHTML("beforeend", html);

    var overlay = document.getElementById("keepsake-bundle-modal-overlay");
    var closeBtn = overlay.querySelector("[data-kb-close]");
    var ctaBtn = overlay.querySelector("[data-kb-cta]");
    var noThanksBtn = overlay.querySelector("[data-kb-no-thanks]");
    var previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    var bundleProduct = document.querySelector("gp-product.bundle-product");
    var bundlePlaceholder = null;
    var bundleWrapper = null;

    if (bundleProduct && bundleProduct.parentElement) {
        bundlePlaceholder = document.createElement("div");
        bundlePlaceholder.setAttribute("data-bundle-placeholder", "true");
        bundleProduct.parentElement.insertBefore(bundlePlaceholder, bundleProduct);
        bundleProduct.style.display = "block";
        if (ctaBtn && ctaBtn.parentElement) {
            ctaBtn.style.display = "none";
            ctaBtn.setAttribute("aria-hidden", "true");
            bundleWrapper = document.createElement("div");
            bundleWrapper.className = "kb-bundle-product";
            bundleWrapper.appendChild(bundleProduct);
            ctaBtn.parentElement.insertBefore(bundleWrapper, ctaBtn);
        }
    }

    function close(reason) {
        document.body.style.overflow = previousOverflow || "";
        if (bundleProduct && bundlePlaceholder && bundlePlaceholder.parentElement) {
            if (bundleWrapper && bundleWrapper.parentElement) {
                bundleWrapper.parentElement.removeChild(bundleWrapper);
            }
            bundlePlaceholder.parentElement.insertBefore(bundleProduct, bundlePlaceholder);
            bundlePlaceholder.remove();
            bundleProduct.style.display = "";
        }
        if (overlay) overlay.remove();
        document.removeEventListener("keydown", onKeyDown, true);
        if (typeof options.onClose === "function") {
            options.onClose({ reason: reason });
        }
    }

    function onKeyDown(e) {
        if (e.key === "Escape") close("escape");
    }

    // close interactions
    closeBtn.addEventListener("click", function () {
        close("close");
    });
    if (noThanksBtn) {
        noThanksBtn.addEventListener("click", function () {
            close("no-thanks");
        });
    }
    overlay.addEventListener("mousedown", function (e) {
        if (e.target === overlay) close("overlay");
    });
    document.addEventListener("keydown", onKeyDown, true);

    // CTA (you wire this up)
    ctaBtn.addEventListener("click", function () {
        ctaBtn.disabled = true;
        ctaBtn.classList.add("kb-loading");

        Promise.resolve()
            .then(function () {
                if (typeof options.onCtaClick === "function") return options.onCtaClick();
                if (typeof window.addKeepsakeBundleToCart === "function") return window.addKeepsakeBundleToCart();
            })
            .then(function () {
                close();
            })
            .catch(function () {
                ctaBtn.disabled = false;
                ctaBtn.classList.remove("kb-loading");
            });
    });

    // focus
    setTimeout(function () {
        closeBtn.focus();
    }, 0);

    return { close: close, overlay: overlay };
}

// 4) Expose a simple invoker you can wire up
window.showKeepsakeBundleModal = function (options) {
    var mergedOptions = options || {};
    if (typeof mergedOptions.onCtaClick !== "function") {
        mergedOptions.onCtaClick = function () {
            // Replace with your cart logic
            // return addBundleToCart({ ... })
            console.log("Bundle CTA clicked");
        };
    }
    return renderKeepsakeBundleModal(mergedOptions);
};
